import React, { useState } from "react";
import NavigateListCustom from "../../../components/navigation/NavigationListCustom";
import { routeName } from "../../../routes/routeName";
import { Button, Card, MenuItem, Typography } from "@mui/material";
import {
  ButtonOutlined,
  ButtonPrimary,
} from "../../../components/button/ButtonCustoms";
import { Navigate } from "react-router-dom";
import { NavigateFunction, useNavigate } from "react-router-dom";
import FilterSelect from "../../../components/select/filterSelect";
import CustomStatus from "../../../components/chip/CustomStatus";
import { FiberManualRecord } from "@mui/icons-material";
import InputTextField from "../../../components/input/inputTextField";
import CheckBoxCustom from "../../../components/checkbox/CheckBoxCustom";
import { dataEvaluation } from "../../../utils/usage_form_evluation";
import { colors } from "../../../constants/colors";
import { icons } from "../../../assets/icons/icons";
import CloseIcon from "@mui/icons-material/Close";
import { unsetLoading } from "../../../store/loading/loading.slice";
import { useDispatch } from "react-redux";
import { alertError, alertSuccess } from "../../../components/alert/swal";
import { advisorFormApi } from "../../../api/advisor-form/advisor-form.api";
import { useTranslation } from "react-i18next";
const CreateEvaluationForm = () => {
  const { t } = useTranslation();
  const navigate: NavigateFunction = useNavigate();
  const dispatch = useDispatch();

  const styledIcon = (icon: React.ReactElement) => {
    return React.cloneElement(icon, {
      style: { fontSize: "32px", color: colors.subPrimary },
    });
  };

  const styledIconDelete = (icon: React.ReactElement) => {
    return React.cloneElement(icon, {
      style: { fontSize: "24px", color: colors.red },
    });
  };

  const defaultIcon = styledIcon(<FiberManualRecord />);
  const deleteIcon = styledIconDelete(<CloseIcon />);

  const [inputValue, setInputValue] = useState<any>({
    form_name: "",
    usage_type_selected: "",
    main_form_evaluation: [
      {
        title_evaluation: "",
        evaluation_item: [""],
      },
    ],
  });

  const handleChangeValue = (name: string, value: any) => {
    setInputValue((prev: any) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const handleEvaluationChange = (id: string, status: boolean) => {
    setInputValue({
      ...inputValue,
      usage_type_selected: id,
    });
  };

  // Function to handle adding new cards (evaluations)
  const addEvaluationCard = () => {
    setInputValue((prev: any) => ({
      ...prev,
      main_form_evaluation: [
        ...prev.main_form_evaluation,
        {
          title_evaluation: "",
          evaluation_item: [""],
        },
      ],
    }));
  };

  // Function to handle changing the title of the evaluation
  const handleTitleChange = (index: number, value: string) => {
    const updatedEvaluations = [...inputValue.main_form_evaluation];
    updatedEvaluations[index].title_evaluation = value;
    setInputValue({ ...inputValue, main_form_evaluation: updatedEvaluations });
  };

  // Function to handle adding sub-items within an evaluation card
  const addEvaluationItem = (index: number) => {
    const updatedEvaluations = [...inputValue.main_form_evaluation];
    updatedEvaluations[index].evaluation_item.push("");
    setInputValue({ ...inputValue, main_form_evaluation: updatedEvaluations });
  };

  // Function to handle sub-item change
  const handleItemChange = (
    cardIndex: number,
    itemIndex: number,
    value: string
  ) => {
    const updatedEvaluations = [...inputValue.main_form_evaluation];
    updatedEvaluations[cardIndex].evaluation_item[itemIndex] = value;
    setInputValue({ ...inputValue, main_form_evaluation: updatedEvaluations });
  };

  // Function to remove an evaluation item
  const removeEvaluationCard = (cardIndex: number) => {
    const updatedEvaluations = [...inputValue.main_form_evaluation];
    updatedEvaluations.splice(cardIndex, 1); // Remove the card at the specified index
    setInputValue({ ...inputValue, main_form_evaluation: updatedEvaluations });
  };

  const removeEvaluationItem = (cardIndex: number, itemIndex: number) => {
    const updatedEvaluations = [...inputValue.main_form_evaluation];
    updatedEvaluations[cardIndex].evaluation_item.splice(itemIndex, 1); // Remove the item at itemIndex
    setInputValue({ ...inputValue, main_form_evaluation: updatedEvaluations });
  };

  function mapInputToApiStructureCreate(input: any) {
    return {
      advisor_form: {
        // id_advisor_form: null,
        advisor_form_name: input.form_name,
        is_advisor:
          input.usage_type_selected === "อาจารย์ที่ปรึกษาวิทยานิพนธ์" ? 1 : 0, // i18n-ignore (value comparison)
        is_class_room:
          input.usage_type_selected === "อาจารย์ที่ปรึกษาประจำชั้น" ? 1 : 0, // i18n-ignore (value comparison)
        is_teacher:
          input.usage_type_selected === "อาจารย์ที่ปรึกษาประจำรายวิชา" ? 1 : 0, // i18n-ignore (value comparison)
        status: "active",
        advisor_form_detail: input.main_form_evaluation.map(
          (evaluation: any, index: number) => ({
            // id_advisor_form_detail: null,
            // id_advisor_form: 0,
            advisor_form_detail_name: evaluation.title_evaluation,
            status: "active",
            advisor_form_detail_sub: evaluation.evaluation_item
              .filter((item: any) => item !== "")
              .map((item: any, subIndex: number) => ({
                // id_advisor_form_detail_sub: null,
                // id_advisor_form_detail: index + 1,
                advisor_form_detail_sub_name: item,
                status: "active",
              })),
          })
        ),
      },
    };
  }

  const handleSave = async (body: any) => {
    if (body) {
      try {
        dispatch(unsetLoading());

        const newBody = mapInputToApiStructureCreate(body);

        const response = await advisorFormApi.createAdvisorForm(newBody);
        if (response.status < 300) {
          alertSuccess(
            t("เพิ่มแบบฟอร์ม"),
            t("เพิ่มแบบฟอร์ม เรียบร้อยแล้ว"),
            undefined,
            () => {
              navigate(routeName.cms.ManageEvaluationForm);
            }
          );
        }
      } catch (error) {
        alertError(t("เพิ่มแบบฟอร์ม ไม่สำเร็จ"));
      } finally {
        dispatch(unsetLoading());
      }
    }
  };

  console.log("inputValue", inputValue);

  return (
    <div className="h-auto">
      {/* breadcrumbs */}
      <NavigateListCustom
        navigateData={[
          {
            name: t("จัดการแบบฟอร์มประเมิน"),
            key: "1",
            pathName: routeName.cms.ManageEvaluationForm,
          },
          {
            name: t("เพิ่มแบบฟอร์ม"),
            key: "2",
            pathName: routeName.cms.CreateEvaluationForm,
          },
        ]}
      />

      {/* header */}
      <section className="my-4">
        <Typography variant="h3">{t("เพิ่มแบบฟอร์ม")}</Typography>
      </section>

      <div className="w-full grid grid-cols-12 gap-4 mt-[40px]">
        <article className="w-full col-span-12 lg:col-span-12 md:col-span-12 sm:col-span-12">
          <InputTextField
            heading={t("ชื่อแบบฟอร์ม")}
            placeholder={t("ระบุชื่อแบบฟอร์ม")}
            value={inputValue.form_name}
            onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
              handleChangeValue("form_name", e.target.value)
            }
          />
        </article>

        <article className="w-full col-span-12 lg:col-span-12 md:col-span-12 sm:col-span-12">
          <Typography variant="h6">{t("ใช้สำหรับ")}</Typography>
          <div style={{ display: "flex", gap: "16px", flexWrap: "wrap" }}>
            {dataEvaluation.map((item, index) => (
              <span
                key={index + 1}
                style={{
                  marginRight: "8rem",
                }}
              >
                <CheckBoxCustom
                  key={item.id}
                  checked={inputValue.usage_type_selected.includes(item.id)}
                  label={t(item.name)}
                  setChecked={(status: boolean) =>
                    handleEvaluationChange(item.id, status)
                  }
                />
              </span>
            ))}
          </div>
        </article>

        {/* Dynamic evaluation cards */}
        {inputValue.main_form_evaluation.map(
          (evaluation: any, cardIndex: number) => (
            <article
              key={cardIndex}
              className="w-full col-span-12 lg:col-span-12 md:col-span-12 sm:col-span-12"
            >
              <Card
                sx={{
                  boxShadow: `0px 5px ${colors.subPrimary}`, // Shadow at the bottom only
                  padding: 2,
                  flexDirection: "row",
                  alignItems: "center",
                  borderRadius: "12px",
                  border: "1px solid #E0E0E0",
                }}
              >
                <InputTextField
                  value={evaluation.title_evaluation}
                  helperText={""}
                  type={"text"}
                  heading={t("หัวข้อหลัก")}
                  placeholder={t("ระบุหัวข้อหลัก")}
                  onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    handleTitleChange(cardIndex, e.target.value)
                  }
                  required
                  row={3}
                  maxRows={5}
                  disablePaddingMultiline
                  multiline
                  inputHeight={"auto"}
                />

                <br />
                <br />

                <Typography variant="h6">{t("หัวข้อย่อย")}</Typography>

                {evaluation.evaluation_item.map(
                  (item: any, itemIndex: number) => (
                    <div
                      key={itemIndex}
                      style={{
                        display: "flex",
                        width: "100%",
                        marginTop: "16px",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <span>{defaultIcon}</span>

                      <InputTextField
                        value={item}
                        helperText={""}
                        type={"text"}
                        heading={""}
                        placeholder={t("ระบุหัวข้อย่อย")}
                        onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                          handleItemChange(
                            cardIndex,
                            itemIndex,
                            e.target.value
                          );

                          // Check if the current item is the last item
                          if (
                            itemIndex ===
                            evaluation.evaluation_item.length - 1
                          ) {
                            addEvaluationItem(cardIndex); // Add a new item if it's the last one
                          }
                        }}
                        borderColor="white"
                      />

                      {itemIndex !== evaluation.evaluation_item.length - 1 ? (
                        <span
                          onClick={() =>
                            removeEvaluationItem(cardIndex, itemIndex)
                          }
                          style={{
                            cursor: "pointer",
                          }}
                        >
                          {deleteIcon}
                        </span>
                      ) : null}
                    </div>
                  )
                )}

                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    marginTop: "8px",
                    justifyContent: "end",
                  }}
                >
                  <Button
                    variant="outlined"
                    color="error"
                    onClick={() => removeEvaluationCard(cardIndex)} // Call the remove function for the card
                  >
                    <img src={icons.bag_cross} alt="Icon" />
                  </Button>
                </div>
              </Card>
            </article>
          )
        )}

        <article className="w-full col-span-12 lg:col-span-12 md:col-span-12 sm:col-span-12 mt-4 ">
          <ButtonPrimary
            onClick={() => {
              addEvaluationCard();
            }}
            mode="add"
            buttonName={t("เพิ่มคำถาม")}
            btnProps={{
              width: "125px",
              margin: "12px",
            }}
          />
        </article>
      </div>

      <section
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "24px",
        }}
      >
        <ButtonOutlined
          onClick={() => {
            navigate(routeName.cms.ManageEvaluationForm);
          }}
          mode="del"
          buttonName={t("ยกเลิก")}
          btnProps={{
            width: "125px",
            margin: "12px",
          }}
        />

        <ButtonPrimary
          onClick={() => {
            handleSave(inputValue);
          }}
          mode="success"
          buttonName={t("ยืนยัน")}
          btnProps={{
            width: "125px",
            margin: "12px",
          }}
        />
      </section>
    </div>
  );
};

export default CreateEvaluationForm;
